import { ShopSelectionWidget, BoothSelectionWidget, BrandSelectionWidget, ProductCategorySelectionWidget } from 'components/FormWidget';

const uiSchema = () => ({
  shop_ids: {
    'ui:widget': ShopSelectionWidget,
    'ui:options': {
      initFilter: {
        for_admin: 1,
      },
    },
  },
  booth_ids: {
    'ui:widget': BoothSelectionWidget,
  },
  brand_ids: {
    'ui:widget': BrandSelectionWidget,
  },
  category_ids: {
    'ui:widget': ProductCategorySelectionWidget,
  },
});

export default uiSchema;
